import * as React from "react"

const RightChevron = () => (
  <svg
    width={8}
    height={14}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Shape</title>
    <defs>
      <path id="a" d="M12 2.633 10.486 1 4 8l6.486 7L12 13.367 7.027 8z" />
    </defs>
    <use
      transform="matrix(-1 0 0 1 12 -1)"
      xlinkHref="#a"
      fillRule="evenodd"
    />
  </svg>
)
export default RightChevron
